// extracted by mini-css-extract-plugin
export default {"imgdiv":"_2067a60f26 bc9230119e","img":"e327503e57 be598e07f5"};